var map = {
	"./gallery-01.jpeg": 6886,
	"./gallery-02.jpeg": 9363,
	"./gallery-03.jpeg": 1628,
	"./gallery-04.jpeg": 7625,
	"./gallery-05.jpeg": 5890,
	"./gallery-06.jpeg": 6479,
	"./gallery-07.jpeg": 8888,
	"./gallery-08.jpeg": 7509,
	"./gallery-09.jpeg": 4174,
	"./gallery-10.jpeg": 4300,
	"./gallery-11.jpeg": 6579,
	"./gallery-12.jpeg": 3958,
	"./gallery-13.jpeg": 7181,
	"./gallery-14.jpeg": 7032,
	"./gallery-15.jpeg": 8095,
	"./gallery-16.jpeg": 4498,
	"./gallery-17.jpeg": 6697,
	"./gallery-18.jpeg": 980,
	"./gallery-19.jpeg": 6187,
	"./gallery-20.jpeg": 8411,
	"./gallery-21.jpeg": 1380,
	"./gallery-22.jpeg": 101,
	"./gallery-23.jpeg": 8142,
	"./gallery-24.jpeg": 9799,
	"./gallery-25.jpeg": 5088,
	"./gallery-26.jpeg": 6737,
	"./gallery-27.jpeg": 3898,
	"./video-01.mp4": 1345,
	"./video-02.mp4": 366
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8872;